<div [formGroup]="gs.gastroForm">
  <div class="h100 l-flex-w t-boxMargin--spacebyPadding summary">
    <div class="w50" style="height: 50px">
      <section class="m-box fulltext">
        <h2>Medical History</h2>
        <button class="t-btn-smart" *ngIf="!es.isClosed && ls.premissions?.Questionnaires" style="margin-bottom: 0.5em" [disabled]="aiSummaryLoading" (click)="getAiSummary()">
          {{ 'GUI.General.Buttons.Populate Smart History' | translate }}
          <span *ngIf="aiSummaryLoading" class="t-btn-smart-spinner"></span>
        </button>
        <textarea formControlName="MedicalHistory" class="scroller scroller-intro fulltext"
          style="min-height: 10em"></textarea>
        <button class="t-btn-edit" *ngIf="!es.isClosed" (click)="
            atS.showAuto(
              gs.gastroForm?.get('MedicalHistory')!,
              'Medical History',
              700
            )
          ">
          Auto Text
        </button>
      </section>
    </div>
    <div class="w50 summary-anamnesis" style="display: flex">
      <div class="summary-anamnesis"></div>
      <div class="w100 summary-recommendations" style="height: 100%; padding: 0">
        <section class="m-box fulltext" style="height: 100%">
          <h2>Purpose of Exam</h2>
          <textarea formControlName="ReasonExamination" class="scroller scroller-intro fulltext"
            style="min-height: 10em"></textarea>
          <button class="t-btn-edit" *ngIf="!es.isClosed" (click)="
              atS.showAuto(
                gs.gastroForm?.get('ReasonExamination')!,
                'Reason Examination',
                701
              )
            ">
            Auto Text
          </button>
        </section>
      </div>
    </div>
  </div>
  <div class="w100">
    <section class="m-box fulltext">
      <h2>Findings</h2>
      <!-- =============================================== -->
      <div class="h100 l-flex-w t-boxMargin--spacebyPadding summary">

        <div class="w50">
          <section class="m-box fulltext" style="height: 10em;">
            <h2>Liver</h2>
            <textarea formControlName="Liver" class="scroller scroller-intro fulltext"></textarea>
            <button class="t-btn-edit" *ngIf="!es.isClosed"
              (click)="atS.showAuto(gs.gastroForm?.get('Liver')!, 'Liver', 702)">
              Auto Text
            </button>
          </section>
        </div>
        <div class="w50">
          <section class="m-box fulltext" style="height: 10em;">
            <h2>Gallbladder</h2>
            <textarea formControlName="Gallbladder" class="scroller scroller-intro fulltext"></textarea>
            <button class="t-btn-edit" *ngIf="!es.isClosed" (click)="
            atS.showAuto(gs.gastroForm?.get('Gallbladder')!, 'Gallbladder', 704)
          ">
              Auto Text
            </button>
          </section>
        </div>
      </div>
      <!-- =============================================== -->

      <!-- =============================================== -->

      <div class="h100 l-flex-w t-boxMargin--spacebyPadding summary">
        <div class="w50">
          <section class="m-box fulltext" style="height: 10em;">
            <h2>Biliary Tract</h2>
            <textarea formControlName="BiliaryTract" class="scroller scroller-intro fulltext"></textarea>
            <button class="t-btn-edit" *ngIf="!es.isClosed" (click)="
            atS.showAuto(
              gs.gastroForm?.get('BiliaryTract')!,
              'BiliaryTract',
              706
            )
          ">
              Auto Text
            </button>
          </section>
        </div>
        <div class="w50">
          <section class="m-box fulltext" style="height: 10em;">
            <h2>Pancreas</h2>
            <textarea formControlName="Pancreas" class="scroller scroller-intro fulltext"></textarea>
            <button class="t-btn-edit" *ngIf="!es.isClosed" (click)="
            atS.showAuto(gs.gastroForm?.get('Pancreas')!, 'Pancreas', 708)
          ">
              Auto Text
            </button>
          </section>
        </div>
      </div>

      <!-- =============================================== -->
      <div class="h100 l-flex-w t-boxMargin--spacebyPadding summary">
        <div class="w50">
          <section class="m-box fulltext" style="height: 10em;">
            <h2>Intestine</h2>
            <textarea formControlName="Intestine" class="scroller scroller-intro fulltext"></textarea>
            <button class="t-btn-edit" *ngIf="!es.isClosed" (click)="
            atS.showAuto(gs.gastroForm?.get('Intestine')!, 'Intestine', 710)
          ">
              Auto Text
            </button>
          </section>
        </div>
        <div class="w50">
          <section class="m-box fulltext" style="height: 10em;">
            <h2>Retro Peritoneum</h2>
            <textarea formControlName="RetroPeritoneum" class="scroller scroller-intro fulltext"></textarea>
            <button class="t-btn-edit" *ngIf="!es.isClosed" (click)="
            atS.showAuto(
              gs.gastroForm?.get('RetroPeritoneum')!,
              'RetroPeritoneum',
              703
            )
          ">
              Auto Text
            </button>
          </section>
        </div>
      </div>
      <!-- =============================================== -->
      <div class="h100 l-flex-w t-boxMargin--spacebyPadding summary">
      <div class="w50">
        <section class="m-box fulltext" style="height: 10em;">
          <h2>Spleen</h2>
          <textarea formControlName="Spleen" class="scroller scroller-intro fulltext"></textarea>
          <button class="t-btn-edit" *ngIf="!es.isClosed" (click)="
          atS.showAuto(
            gs.gastroForm?.get('Spleen')!,
            'Spleen',
            712
          )
        ">
            Auto Text
          </button>
        </section>
      </div>
     
        <div class="w50">
          <section class="m-box fulltext" style="height: 10em;">
            <h2>Abdominal Aorta</h2>
            <textarea formControlName="AbdominalAorta" class="scroller scroller-intro fulltext"></textarea>
            <button class="t-btn-edit" *ngIf="!es.isClosed" (click)="
            atS.showAuto(
              gs.gastroForm?.get('AbdominalAorta')!,
              'AbdominalAorta',
              705
            )
          ">
              Auto Text
            </button>
          </section>
        </div>
      </div>
        <div class="h100 l-flex-w t-boxMargin--spacebyPadding summary">
        <div class="w50">
          <section class="m-box fulltext" style="height: 10em;">
            <h2>Kidneys</h2>
            <textarea formControlName="Kidneys" class="scroller scroller-intro fulltext"></textarea>
            <button class="t-btn-edit" *ngIf="!es.isClosed"
              (click)="atS.showAuto(gs.gastroForm?.get('Kidneys')!, 'Kidneys', 707)">
              Auto Text
            </button>
          </section>
        </div>
        
        <div class="w50">
          <section class="m-box fulltext" style="height: 10em;">
            <h2>Bladder</h2>
            <textarea formControlName="Bladder" class="scroller scroller-intro fulltext"></textarea>
            <button class="t-btn-edit" *ngIf="!es.isClosed"
            (click)="atS.showAuto(gs.gastroForm?.get('Bladder')!, 'Bladder', 709)">
            Auto Text
          </button>
        </section>
      </div>
    </div>
    <div>
    <div class="h100 l-flex-w t-boxMargin--spacebyPadding summary">
        <div class="w50">
          <section class="m-box fulltext" style="height: 10em;">
            <h2>Prostate</h2>
            <textarea formControlName="Prostate" class="scroller scroller-intro fulltext"></textarea>
            <button class="t-btn-edit" *ngIf="!es.isClosed" (click)="
            atS.showAuto(gs.gastroForm?.get('Prostate')!, 'Prostate', 711)
          ">
              Auto Text
            </button>
          </section>
        </div>
      </div>
    
      <!-- =============================================== -->

   
    </div>

   
    <app-gastro-summary [hideSignature]="true"></app-gastro-summary>



      <app-exam-diagnoses></app-exam-diagnoses>

      <div class="w100 summary">
        <section class="m-box">
          <h2>Summary of Exam</h2>
          <angular-editor formControlName="Summary" [config]="editorConfig" style="width: 100%"></angular-editor>
          <button class="t-btn-edit" *ngIf="! es.isClosed" (click)="atS.showAuto(gs.gastroForm.get('Summary')!,'Summary',712, true, true)">Auto Text</button>

        </section>
      </div>

      <!-- =============== Exam Signature (Start) =============== -->
      <app-gastro-summary [signOnly]="true"></app-gastro-summary>
      <!-- =============== Exam Signature (End) =============== -->
    </section>
  </div>
</div>